import { configureStore } from "@reduxjs/toolkit";

import { api } from "./api";
import { appReducer } from "./app/slice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    [api.reducerPath]: api.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware)
});
